import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { graphql } from "gatsby";
import { Box, Flex, Button, Container, Heading, Grid as ThemeUIGrid } from "theme-ui";
import { Avatar, Banner, Grid, GumroadButton, GumroadOverlay, TinyFormCK, Testimonial } from "@swizec/gatsby-theme-course-platform";
import { NavGrid, ChapterHeading, HomeTitle } from "../components/homepage";
export const pageQuery = graphql`
  query {
    ThaiWood: file(relativePath: { eq: "testimonial-avatars/thaiwood.png" }) {
      childImageSharp {
        fluid(maxWidth: 110, maxHeight: 110) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    AlNotara: file(relativePath: { eq: "testimonial-avatars/alnotara.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 110, maxHeight: 110) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    MarekC: file(relativePath: { eq: "testimonial-avatars/MarekC.png" }) {
      childImageSharp {
        fluid(maxWidth: 110, maxHeight: 110) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    AdamRackis: file(
      relativePath: { eq: "testimonial-avatars/adamrackis.jpeg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 110, maxHeight: 110) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    DavidWells: file(
      relativePath: { eq: "testimonial-avatars/davidwells.jpeg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 110, maxHeight: 110) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Banner mdxType="Banner">
      <HomeTitle mdxType="HomeTitle" />
      <Box sx={{
        my: "auto",
        mb: 4
      }} mdxType="Box" />
      <ChapterHeading sx={{
        mb: 2
      }} mdxType="ChapterHeading" />
      <NavGrid mdxType="NavGrid">
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/getting-started"
            }}>{`Getting Started`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-pros-cons"
            }}>{`Serverless Pros & Cons`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-flavors"
            }}>{`Choosing Providers`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-dx"
            }}>{`Create Good serverless DX`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-architecture-principles"
            }}>{`Architecture principles`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-elements"
            }}>{`Lambdas, queues, etc`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/robust-backend-design"
            }}>{`Robust backend design`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/databases"
            }}>{`Where to store data`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-rest-api"
            }}>{`Creating a REST API`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-graphql"
            }}>{`Using GraphQL`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/lambda-pipelines"
            }}>{`Lambda pipelines`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-monitoring"
            }}>{`Monitoring `}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/dev-qa-prod"
            }}>{`Dev, QA, and prod`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-performance"
            }}>{`Serverless performance`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-chrome-puppeteer"
            }}>{`Using Chrome puppeteer`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/handling-secrets"
            }}>{`Handling secrets`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/serverless-authentication"
            }}>{`Dealing with authentication`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/glossary"
            }}>{`Glossary`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/appendix-more-databases"
            }}>{`Appendix: More databases`}</a></li>
        </ul>
      </NavGrid>
    </Banner>
    <Container sx={{
      py: 3
    }} mdxType="Container">
      <Testimonial quote={<>
      I have really enjoyed the approach you've taken with the book. It's got me
      thinking practically about Serverless as a whole, but more specifically
      each aspect that contributes to a robust implementation of Serverless for
      production. <b>I read a third of the book the first night I had it!</b>
    </>} image={props.data.AlNotara.childImageSharp.fluid.src} name="Al Notara" company="freelance web developer" mdxType="Testimonial" />
      <p>{`Hello! 👋`}</p>
      <p>{`Are you a frontend engineer diving into backend? Do you have just that one bit of code that can't run in the browser? Something that deals with secrets and APIs?`}</p>
      <lite-youtube {...{
        "videoid": "udqyBqCgLrU",
        "videostartat": "0"
      }}></lite-youtube>
      <p>{`That's what cloud functions are for my friend. You take a JavaScript function, run it on serverless, get a URL, and voila.`}</p>
      <p>{`But that's easy mode. Any tutorial can teach you that.`}</p>
      <p><strong parentName="p">{`What happens when you wanna build a real backend?`}</strong>{` When you want to understand what's going on? Have opinions on REST vs GraphQL, NoSQL vs. SQL, databases, queues, talk about performance, cost, data processing, deployment strategies, developer experience?`}</p>
      <p>{`🤯`}</p>
      <Testimonial quote={<>
      <p>
        Serverless Handbook is a wonderfully written introduction to serverless.
        It walks through serverless design principles and constraints, and
        discusses the various providers, and their tradeoffs. It moves on to
        cover a broad overview of the most common aws services, and how to use
        them with the Serverless framework.
      </p>
      <p>
        This book is a must-read for anyone new to serverless tech, looking to
        get up to speed.
      </p>
    </>} image={props.data.AdamRackis.childImageSharp.fluid.src} name="Adam Rackis" company="engineer at Spotify" mdxType="Testimonial" />
      <h2 {...{
        "id": "get-your-free-chapter"
      }}>{`Get your free chapter!`}</h2>
      <p>{`Access to this chapter immediately, extra free chapter and Serverless crash course in your email ✌️`}</p>
      <TinyFormCK copyBefore="" submitText="Send crash course! 💌" onSuccess={() => setTimeout(props.unlockCurrentPage, 2000)} mdxType="TinyFormCK" />
      <br />
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><span parentName="a" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px",
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2014c-8%203-8%202-8%2059%200%2056%200%2055%207%2059%204%203%20373%203%20378%200%206-4%206-3%206-59%200-57%200-56-8-60-6-2-370-2-375%201m10%2014l-1%209v9h4c6%200%2010-5%207-8-2-1-2-2-1-3%201-3%201-5-1-6-1-2-7-3-8-1m15%205l-1%206c0%206%202%209%206%207h3c2%200%202%200%202-6l-1-7c-1-2-3%202-3%206l-1%205c-2%200-3-2-3-8%200-4-1-5-2-3m13%203l3%207c2%205%202%206-1%206l-2%202c0%201%204%201%206-1l4-14c1-4-2-3-3%202s-1%205-4-2c-1-5-3-5-3%200m38-2c-4%205-1%2013%204%2013%202%200%206-5%206-7%200-6-7-10-10-6m12-1c-1%202%202%2013%204%2013l2-3c0-4%201-4%203%200%200%202%201%203%202%203%202-1%205-12%204-13h-1l-3%205-2-3c-1-3-1-3-3-2l-1%204-1%203-1-2c0-5-2-8-3-5m28%201c-4%204-1%2013%204%2013%202%200%205-4%205-7%200-7-6-10-9-6m13%205l1%207c1%200%202-1%202-5s1-6%202-6c2%200%202%201%202%205%201%207%203%208%204%201%200-7-1-9-6-9l-5%201v6m-26%2021c-6%202-9%206-9%2010%200%203%208%203%2010%200%204-5%2010-3%209%202%200%202-1%203-6%204-10%201-14%205-14%2013%200%209%2011%2014%2018%208%204-2%204-3%206%200%201%203%203%203%206-1%203-3%203-3%202-6-2-2-2-5-2-12l-1-12c-3-6-12-8-19-6m93%200c-7%202-11%206-11%2010%200%203%209%203%209%200%201-2%206-4%208-2l2%204c0%202-1%202-7%203-9%202-13%206-13%2013%200%205%201%208%205%2010%203%202%2010%201%2013-1l3-2%202%202c3%203%204%203%207-1%203-3%203-3%202-5-2-2-2-5-2-13%200-9%200-11-2-13-4-5-11-7-16-5m-52%202c-3%202-3%202-4%201%200-2-2-2-5-2h-4v38h10V85c0-14%201-16%205-16%203%200%203%201%203%2017l1%2013h9V86c0-14%201-17%205-17%203%200%204%202%204%2016l1%2014h3l5-1V66c-3-6-11-8-16-3l-3%203-2-3c-3-4-9-4-12-1m80-1c-2%200-3%205%200%207l6%201c6-1%206-1-4%2013-4%206-5%208-5%2012%200%205%200%205%205%203s13-2%2017%200c5%201%206%201%206-3s-5-8-12-8c-2%200-3-1-1-2l6-9c6-9%207-13%205-14h-23m38%200c-12%205-14%2028-3%2036%2012%208%2025-2%2024-20-1-13-11-20-21-16m38%202c-2%202-2%202-3%200%200-2-1-2-5-2h-4v19l1%2019h9V85c1-13%201-16%205-16%203%200%203%202%204%2016l1%2014h9V68c-2-7-11-11-17-5m44%204c-1%201%200%203%206%208l6%206-6%207c-6%206-7%209-5%209s16-15%2016-16l-8-8c-6-6-8-7-9-6m-80%203c-4%205-2%2022%203%2022%204%200%207-6%206-16-1-8-5-11-9-6m-36%2032c-7%202-7%202%202%203%2010%201%2010%201%204%2016h2c4-4%208-16%206-19h-14m-103%202a87%2087%200%2000105%209c4-3%201-3-7%200-14%204-19%205-33%206-21%201-39-3-57-12l-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/ca0a1/buy-now-amazon.webp 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ac56/buy-now-amazon.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/e92b6/buy-now-amazon.png 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png",
                "alt": "buy now amazon",
                "title": "buy now amazon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></a></p>
      <h2 {...{
        "id": "dive-into-modern-backend-understand-any-backend"
      }}>{`Dive into modern backend. Understand any backend`}</h2>
      <p style={{
        fontSize: "1.1em"
      }}>
  <strong>Serverless Handbook</strong> shows you how with{" "}
  <strong>360 pages</strong> for people like you getting into backend
  programming.
      </p>
      <p>{`With `}<strong parentName="p">{`digital + paperback content`}</strong>{` Serverless Handbook has been more than 1 year in development. Lessons learned from 14 years of building production grade websites and webapps.`}</p>
      <Testimonial quote="With Serverless Handbook, Swiz teaches the truths of distributed systems – things will fail – but he also gives you insight on how to architect projects using reliability and resilience perspectives so you can monitor and recover." image={props.data.ThaiWood.childImageSharp.fluid.src} name="Thai Wood" company="author of Resilience Roundup" mdxType="Testimonial" />
      <p>{`If you want to understand backends, grok serverless, or just get a feel for modern backend development, this is the book for you.`}</p>
      <p>{`Serverless Handbook full of `}<strong parentName="p">{`color illustrations`}</strong>{`, `}<strong parentName="p">{`code you can try`}</strong>{`, and `}<strong parentName="p">{`insights you can learn`}</strong>{`. But it's not a cookbook and it's not a tutorial.`}</p>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><figure parentName="a" {...{
            "className": "gatsby-resp-image-figure",
            "style": {
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
    `}<span parentName="figure" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "890px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.05381165919282%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v112h115a4911%204911%200%200010-3v-2c-1-1%205-2%2013-2l7%201c-2%202-1%202%205%201h10l6-1%2017-1a1530%201530%200%200074-4c-7%200-18-3-17-6l-1-1%201-2h-1c-3%200-3-1%201-3%202%200%203-1%203-2l-4%201-3%201-1-1-1-1v-1c-1%200%200-2%202-3l4-3-4%202-4%202-6-3-8-3-2-1%201%2013v13h-22v-3a1052%201052%200%2000-1-55v-11l16-10a101%20101%200%200118-10l-1-2c-2-1-7%202-7%203l-1%201h-1l-6%203-8%205-3%202-3%201c-2%203-5%203-5%201l-1-10a2273%202273%200%2000-3-108%201392%201392%200%2001112%201l-7-2c-3%200-4-3-3-3%202-2%201-3-1-3s-3-1-3-2l-2-2%2022-7%2016-4-161-1H0v113M195%203c-9%201-13%203-16%206l-3%203%2021%201a280%20280%200%200130%200c1%202%202%201%204-2l2-4c-3-3-25-6-38-4m-69%2036a11449%2011449%200%20005%20160l1%2017h2c2%200%202%200%202-9a3180%203180%200%2001-9-162c0-11-1-14-1-6M38%2056a391%20391%200%2000-4%2024%20364%20364%200%2000-5%2032%20432%20432%200%2000-6%2036%205829%205829%200%2000-11%2072c0%202%202%202%2014%202%2014%200%2021-1%2017-2-2-1-3-11-3-49a1135%201135%200%2000-2-115m257%2062c-6%202-8%204-8%205l-1%202%204%202%203-3c1-5%205-5%207-1l1%2013c-2%201%205%205%207%205l1-2-1-3h-1c-2%200-2-1-2-7l-2-11v-5l-8%205m-42%2028c-1%203-1%203-5%202l-4%201h-5l-4%201%202%201c2%200%203%202%2014%2013l4%203%201%201v5c-2%201-3%201-5-3-4-5-4-5-4-2%202%207%202%208%200%208-3%200-4-1-5-8%200-6-2-12-4-12l-6%2012-3%201c-2%201-3%201-3%203l1%208v5l6%202c7%204%206%204%2014-1s8-5%208%201c0%204%200%205-2%206-3%201-1%202%202%202l5-5c2-2%203-3%205-3l7-2c3-2%204-2%205-1l2%201c3%200%206%202%206%204s-5%203-9%203l-4-1%201%208v12l1%203h16v-12c0-2%2014-9%2015-9l-9%206c-4%203-4%203-4%208v6h11c29%202%2028%202%2028-1%200-1-1-2-3-2-3%200-6-3-5-6l-1-3v-5c2-3%204-4%204-1h2v-3l2-1c2-1%202%200%202%203s0%203%202%203c1-1%202%200%204%202%202%203%207%203%206%200-1-8-1-9%201-10%202-2%205%202%204%204l-1%208c0%206-2%208-3%205-1-1-6%201-5%203h3l5%201%202%201-1-2c-2-1-1-2%202-2%203-1%203-1%203-4-1-2-1-3%202-6l3-2h-3c-3%201-4%200-4-5l-1-3h-3l-3-2-4%201c-2%202-4%202-4-1l2-1%202-1%202-1%201%201h3c1-1%204-2%205-1l2-1h4c2-1%202-1%200-1-2-1-2-1-1-3%200-4-4-4-6-1-2%205-9%205-9%201%200-2%202-3%204-2l1-1-3-1-3-2c0-2-3-4-3-2h-1l-4-1c-3%200-3%201-3%203s0%202%203%202c2%200%203%200%202%202l-1%203v3l-1%203c-1%202-1%202-3%201h-4c-2%201-2%201-2-8l-1-8-1-4v4l-1%205c-3%200-3%200-4-10l1-8h1l-2-2h-2l3%202h-4c-2%200-3-1-3-2h-1c-2%200-2%200%200-1%201-1%201-1-4-2-4%200-5-1-5-3-1-4-2-3-5%201l-4%205-1%202-3%204-2%203c1%201%2015-8%2015-9l1-2%201%201%201%201%203%201-2%201h-1c3%202%204%203%204%201-1-1%200-1%201-1v18h-3c-3%200-3-1-3-4l-1-4-15%207-14%208c-1-3%200-9%201-10l1-3%202-5%202-3h-2c-2%200-3-1-3-4-1-4-2-4-7-3-3%200-3%200-1%202%202%201%203%203%201%203l-4-2-6-3c-2%200-2-1-2-2l4-1c5%200%205-1%202-4s-6-3-8%200m-47%208c-2%202-2%204-2%207-1%205%202%205%209%200%207-4%207-7%202-8h-5l-4%201m-101%2013c-1%203%202%2041%203%2043l-1-39-2-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/69021b72e882726314125a99b60ce6d9/ca0a1/serverless-handbook-bookshelf.webp 223w", "/static/69021b72e882726314125a99b60ce6d9/75680/serverless-handbook-bookshelf.webp 445w", "/static/69021b72e882726314125a99b60ce6d9/8d1ba/serverless-handbook-bookshelf.webp 890w", "/static/69021b72e882726314125a99b60ce6d9/3838e/serverless-handbook-bookshelf.webp 1335w", "/static/69021b72e882726314125a99b60ce6d9/e11e5/serverless-handbook-bookshelf.webp 1780w", "/static/69021b72e882726314125a99b60ce6d9/0811d/serverless-handbook-bookshelf.webp 6000w"],
                  "sizes": "(max-width: 890px) 100vw, 890px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/69021b72e882726314125a99b60ce6d9/853b2/serverless-handbook-bookshelf.jpg 223w", "/static/69021b72e882726314125a99b60ce6d9/0a4fe/serverless-handbook-bookshelf.jpg 445w", "/static/69021b72e882726314125a99b60ce6d9/7f80b/serverless-handbook-bookshelf.jpg 890w", "/static/69021b72e882726314125a99b60ce6d9/dc6ba/serverless-handbook-bookshelf.jpg 1335w", "/static/69021b72e882726314125a99b60ce6d9/2d2e5/serverless-handbook-bookshelf.jpg 1780w", "/static/69021b72e882726314125a99b60ce6d9/857b3/serverless-handbook-bookshelf.jpg 6000w"],
                  "sizes": "(max-width: 890px) 100vw, 890px",
                  "type": "image/jpeg"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/static/69021b72e882726314125a99b60ce6d9/7f80b/serverless-handbook-bookshelf.jpg",
                  "alt": "Serverless Handbook on your bookshelf",
                  "title": "Serverless Handbook on your bookshelf",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
              "className": "gatsby-resp-image-figcaption"
            }}>{`Serverless Handbook on your bookshelf`}</figcaption>{`
  `}</figure></a></p>
      <p>{`Yes, there's a couple tutorials to get you started, to show you how it fits together, but the focus is on high-level concepts.`}</p>
      <p style={{
        fontSize: "1.1em"
      }}>
  <strong>Ideas</strong>, <strong>tactics</strong>, and{" "}
  <strong>mindsets</strong> that you need. Because every project is different.
      </p>
      <p>{`The Serverless Handbook takes you `}<em parentName="p">{`from your very first cloud function to modern backend mastery`}</em>{`. In the words of an early reader:`}</p>
      <Testimonial quote={<>
      <p>
        Serverless Handbook taught me high-leveled topics. I don't like recipe
        courses and these chapters helped me to feel like I'm not a total noob
        anymore.
      </p>
      <p>
        The hand-drawn diagrams and high-leveled descriptions gave me the
        feeling that I don't have any critical "knowledge gaps" anymore.
      </p>
    </>} image={props.data.MarekC.childImageSharp.fluid.src} name="Marek C." company="frontend engineer" mdxType="Testimonial" />
      <blockquote>
      </blockquote>
      <p>{`If you can JavaScript, you can backend.`}</p>
      <p>{`Plus it looks great on your bookshelf 😉`}</p>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><span parentName="a" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px",
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2014c-8%203-8%202-8%2059%200%2056%200%2055%207%2059%204%203%20373%203%20378%200%206-4%206-3%206-59%200-57%200-56-8-60-6-2-370-2-375%201m10%2014l-1%209v9h4c6%200%2010-5%207-8-2-1-2-2-1-3%201-3%201-5-1-6-1-2-7-3-8-1m15%205l-1%206c0%206%202%209%206%207h3c2%200%202%200%202-6l-1-7c-1-2-3%202-3%206l-1%205c-2%200-3-2-3-8%200-4-1-5-2-3m13%203l3%207c2%205%202%206-1%206l-2%202c0%201%204%201%206-1l4-14c1-4-2-3-3%202s-1%205-4-2c-1-5-3-5-3%200m38-2c-4%205-1%2013%204%2013%202%200%206-5%206-7%200-6-7-10-10-6m12-1c-1%202%202%2013%204%2013l2-3c0-4%201-4%203%200%200%202%201%203%202%203%202-1%205-12%204-13h-1l-3%205-2-3c-1-3-1-3-3-2l-1%204-1%203-1-2c0-5-2-8-3-5m28%201c-4%204-1%2013%204%2013%202%200%205-4%205-7%200-7-6-10-9-6m13%205l1%207c1%200%202-1%202-5s1-6%202-6c2%200%202%201%202%205%201%207%203%208%204%201%200-7-1-9-6-9l-5%201v6m-26%2021c-6%202-9%206-9%2010%200%203%208%203%2010%200%204-5%2010-3%209%202%200%202-1%203-6%204-10%201-14%205-14%2013%200%209%2011%2014%2018%208%204-2%204-3%206%200%201%203%203%203%206-1%203-3%203-3%202-6-2-2-2-5-2-12l-1-12c-3-6-12-8-19-6m93%200c-7%202-11%206-11%2010%200%203%209%203%209%200%201-2%206-4%208-2l2%204c0%202-1%202-7%203-9%202-13%206-13%2013%200%205%201%208%205%2010%203%202%2010%201%2013-1l3-2%202%202c3%203%204%203%207-1%203-3%203-3%202-5-2-2-2-5-2-13%200-9%200-11-2-13-4-5-11-7-16-5m-52%202c-3%202-3%202-4%201%200-2-2-2-5-2h-4v38h10V85c0-14%201-16%205-16%203%200%203%201%203%2017l1%2013h9V86c0-14%201-17%205-17%203%200%204%202%204%2016l1%2014h3l5-1V66c-3-6-11-8-16-3l-3%203-2-3c-3-4-9-4-12-1m80-1c-2%200-3%205%200%207l6%201c6-1%206-1-4%2013-4%206-5%208-5%2012%200%205%200%205%205%203s13-2%2017%200c5%201%206%201%206-3s-5-8-12-8c-2%200-3-1-1-2l6-9c6-9%207-13%205-14h-23m38%200c-12%205-14%2028-3%2036%2012%208%2025-2%2024-20-1-13-11-20-21-16m38%202c-2%202-2%202-3%200%200-2-1-2-5-2h-4v19l1%2019h9V85c1-13%201-16%205-16%203%200%203%202%204%2016l1%2014h9V68c-2-7-11-11-17-5m44%204c-1%201%200%203%206%208l6%206-6%207c-6%206-7%209-5%209s16-15%2016-16l-8-8c-6-6-8-7-9-6m-80%203c-4%205-2%2022%203%2022%204%200%207-6%206-16-1-8-5-11-9-6m-36%2032c-7%202-7%202%202%203%2010%201%2010%201%204%2016h2c4-4%208-16%206-19h-14m-103%202a87%2087%200%2000105%209c4-3%201-3-7%200-14%204-19%205-33%206-21%201-39-3-57-12l-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/ca0a1/buy-now-amazon.webp 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ac56/buy-now-amazon.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/e92b6/buy-now-amazon.png 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png",
                "alt": "buy now amazon",
                "title": "buy now amazon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></a></p>
      <p>{`Cheers,`}<br />{`
~Swizec`}</p>
      <Grid gap={2} sx={{
        fontWeight: 'bold',
        py: 3
      }} mdxType="Grid">
        <ul>
          <li parentName="ul">{`Get started with Serverless backend technologies`}</li>
          <li parentName="ul">{`Build your first backends, or your 10th in a new way ;)`}</li>
          <li parentName="ul">{`Designed for frontend engineers diving into backend tech for the first time`}</li>
          <li parentName="ul">{`Learn all about lambdas and queues and databases`}</li>
          <li parentName="ul">{`Build server-side technologies with JavaScript and TypeScript`}</li>
          <li parentName="ul">{`Support your apps with functions in the cloud`}</li>
          <li parentName="ul">{`A reference handbook that stands by your side as you work`}</li>
          <li parentName="ul">{`Pick and choose, read the chapters you need right now`}</li>
          <li parentName="ul">{`Access yours forever`}</li>
          <li parentName="ul">{`Live digital version with your Kindle or Paperback`}</li>
          <li parentName="ul">{`Available wherever Amazon sends books`}</li>
        </ul>
      </Grid>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><span parentName="a" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px",
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2014c-8%203-8%202-8%2059%200%2056%200%2055%207%2059%204%203%20373%203%20378%200%206-4%206-3%206-59%200-57%200-56-8-60-6-2-370-2-375%201m10%2014l-1%209v9h4c6%200%2010-5%207-8-2-1-2-2-1-3%201-3%201-5-1-6-1-2-7-3-8-1m15%205l-1%206c0%206%202%209%206%207h3c2%200%202%200%202-6l-1-7c-1-2-3%202-3%206l-1%205c-2%200-3-2-3-8%200-4-1-5-2-3m13%203l3%207c2%205%202%206-1%206l-2%202c0%201%204%201%206-1l4-14c1-4-2-3-3%202s-1%205-4-2c-1-5-3-5-3%200m38-2c-4%205-1%2013%204%2013%202%200%206-5%206-7%200-6-7-10-10-6m12-1c-1%202%202%2013%204%2013l2-3c0-4%201-4%203%200%200%202%201%203%202%203%202-1%205-12%204-13h-1l-3%205-2-3c-1-3-1-3-3-2l-1%204-1%203-1-2c0-5-2-8-3-5m28%201c-4%204-1%2013%204%2013%202%200%205-4%205-7%200-7-6-10-9-6m13%205l1%207c1%200%202-1%202-5s1-6%202-6c2%200%202%201%202%205%201%207%203%208%204%201%200-7-1-9-6-9l-5%201v6m-26%2021c-6%202-9%206-9%2010%200%203%208%203%2010%200%204-5%2010-3%209%202%200%202-1%203-6%204-10%201-14%205-14%2013%200%209%2011%2014%2018%208%204-2%204-3%206%200%201%203%203%203%206-1%203-3%203-3%202-6-2-2-2-5-2-12l-1-12c-3-6-12-8-19-6m93%200c-7%202-11%206-11%2010%200%203%209%203%209%200%201-2%206-4%208-2l2%204c0%202-1%202-7%203-9%202-13%206-13%2013%200%205%201%208%205%2010%203%202%2010%201%2013-1l3-2%202%202c3%203%204%203%207-1%203-3%203-3%202-5-2-2-2-5-2-13%200-9%200-11-2-13-4-5-11-7-16-5m-52%202c-3%202-3%202-4%201%200-2-2-2-5-2h-4v38h10V85c0-14%201-16%205-16%203%200%203%201%203%2017l1%2013h9V86c0-14%201-17%205-17%203%200%204%202%204%2016l1%2014h3l5-1V66c-3-6-11-8-16-3l-3%203-2-3c-3-4-9-4-12-1m80-1c-2%200-3%205%200%207l6%201c6-1%206-1-4%2013-4%206-5%208-5%2012%200%205%200%205%205%203s13-2%2017%200c5%201%206%201%206-3s-5-8-12-8c-2%200-3-1-1-2l6-9c6-9%207-13%205-14h-23m38%200c-12%205-14%2028-3%2036%2012%208%2025-2%2024-20-1-13-11-20-21-16m38%202c-2%202-2%202-3%200%200-2-1-2-5-2h-4v19l1%2019h9V85c1-13%201-16%205-16%203%200%203%202%204%2016l1%2014h9V68c-2-7-11-11-17-5m44%204c-1%201%200%203%206%208l6%206-6%207c-6%206-7%209-5%209s16-15%2016-16l-8-8c-6-6-8-7-9-6m-80%203c-4%205-2%2022%203%2022%204%200%207-6%206-16-1-8-5-11-9-6m-36%2032c-7%202-7%202%202%203%2010%201%2010%201%204%2016h2c4-4%208-16%206-19h-14m-103%202a87%2087%200%2000105%209c4-3%201-3-7%200-14%204-19%205-33%206-21%201-39-3-57-12l-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/ca0a1/buy-now-amazon.webp 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ac56/buy-now-amazon.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/e92b6/buy-now-amazon.png 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png",
                "alt": "buy now amazon",
                "title": "buy now amazon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></a></p>
      <Testimonial quote={<>
      <p>
        This handbook is a fantastic overview of what it means to embrace
        serverless technology. After explaining what the heck "serverless"
        really means, the book digs deep into the core elements of serverless in
        an easy-to-follow illustrative manner with ready deployable code!
      </p>
      <p>
        After learning about all the primitives (functions/queues/s3/etc.) you'd
        need as a serverless dev, the book also covers other critical
        operational aspects like observability, multi-staged deployments &
        handling secrets.
      </p>
      <p>
        It's a great book on using infrastructure-as-code tools like the
        serverless framework to achieve more with less.
      </p>
      <p>
        I'm highly impressed by Swizecs's approach to teaching devs how to adopt
        new serverless technology.
      </p>
    </>} image={props.data.DavidWells.childImageSharp.fluid.src} name="David Wells" company="Serverless Framework core contributor" mdxType="Testimonial" />
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><span parentName="a" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px",
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2014c-8%203-8%202-8%2059%200%2056%200%2055%207%2059%204%203%20373%203%20378%200%206-4%206-3%206-59%200-57%200-56-8-60-6-2-370-2-375%201m10%2014l-1%209v9h4c6%200%2010-5%207-8-2-1-2-2-1-3%201-3%201-5-1-6-1-2-7-3-8-1m15%205l-1%206c0%206%202%209%206%207h3c2%200%202%200%202-6l-1-7c-1-2-3%202-3%206l-1%205c-2%200-3-2-3-8%200-4-1-5-2-3m13%203l3%207c2%205%202%206-1%206l-2%202c0%201%204%201%206-1l4-14c1-4-2-3-3%202s-1%205-4-2c-1-5-3-5-3%200m38-2c-4%205-1%2013%204%2013%202%200%206-5%206-7%200-6-7-10-10-6m12-1c-1%202%202%2013%204%2013l2-3c0-4%201-4%203%200%200%202%201%203%202%203%202-1%205-12%204-13h-1l-3%205-2-3c-1-3-1-3-3-2l-1%204-1%203-1-2c0-5-2-8-3-5m28%201c-4%204-1%2013%204%2013%202%200%205-4%205-7%200-7-6-10-9-6m13%205l1%207c1%200%202-1%202-5s1-6%202-6c2%200%202%201%202%205%201%207%203%208%204%201%200-7-1-9-6-9l-5%201v6m-26%2021c-6%202-9%206-9%2010%200%203%208%203%2010%200%204-5%2010-3%209%202%200%202-1%203-6%204-10%201-14%205-14%2013%200%209%2011%2014%2018%208%204-2%204-3%206%200%201%203%203%203%206-1%203-3%203-3%202-6-2-2-2-5-2-12l-1-12c-3-6-12-8-19-6m93%200c-7%202-11%206-11%2010%200%203%209%203%209%200%201-2%206-4%208-2l2%204c0%202-1%202-7%203-9%202-13%206-13%2013%200%205%201%208%205%2010%203%202%2010%201%2013-1l3-2%202%202c3%203%204%203%207-1%203-3%203-3%202-5-2-2-2-5-2-13%200-9%200-11-2-13-4-5-11-7-16-5m-52%202c-3%202-3%202-4%201%200-2-2-2-5-2h-4v38h10V85c0-14%201-16%205-16%203%200%203%201%203%2017l1%2013h9V86c0-14%201-17%205-17%203%200%204%202%204%2016l1%2014h3l5-1V66c-3-6-11-8-16-3l-3%203-2-3c-3-4-9-4-12-1m80-1c-2%200-3%205%200%207l6%201c6-1%206-1-4%2013-4%206-5%208-5%2012%200%205%200%205%205%203s13-2%2017%200c5%201%206%201%206-3s-5-8-12-8c-2%200-3-1-1-2l6-9c6-9%207-13%205-14h-23m38%200c-12%205-14%2028-3%2036%2012%208%2025-2%2024-20-1-13-11-20-21-16m38%202c-2%202-2%202-3%200%200-2-1-2-5-2h-4v19l1%2019h9V85c1-13%201-16%205-16%203%200%203%202%204%2016l1%2014h9V68c-2-7-11-11-17-5m44%204c-1%201%200%203%206%208l6%206-6%207c-6%206-7%209-5%209s16-15%2016-16l-8-8c-6-6-8-7-9-6m-80%203c-4%205-2%2022%203%2022%204%200%207-6%206-16-1-8-5-11-9-6m-36%2032c-7%202-7%202%202%203%2010%201%2010%201%204%2016h2c4-4%208-16%206-19h-14m-103%202a87%2087%200%2000105%209c4-3%201-3-7%200-14%204-19%205-33%206-21%201-39-3-57-12l-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/ca0a1/buy-now-amazon.webp 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ac56/buy-now-amazon.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/e92b6/buy-now-amazon.png 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png",
                "alt": "buy now amazon",
                "title": "buy now amazon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></a></p>
      <h1 {...{
        "id": "whats-in-serverless-handbook"
      }}>{`What's in Serverless Handbook?`}</h1>
      <p>{`360 pages, 19 chapters, 6 full projects, hand-drawn diagrams, beautiful chapter art, best-looking cover in tech. ✌️`}</p>
      <p>{`Watch the walkthrough or keep reading.`}</p>
      <lite-youtube {...{
        "videoid": "WC-mEf4K9as",
        "videostartat": "1772"
      }}></lite-youtube>
      <p><strong parentName="p">{`Getting Started`}</strong>{` walks you through the history of servers and `}<em parentName="p">{`why`}</em>{` serverless exists.`}</p>
      <p><strong parentName="p">{`Serverless Pros & Cons`}</strong>{` helps you make informed decisions. Does serverless fit your project?`}</p>
      <p><strong parentName="p">{`AWS, Azure, Vercel, Netlify, or Firebase?‌`}</strong>{` talks about choosing a provider and their tradeoffs.`}</p>
      <p><strong parentName="p">{`Good serverless DX`}</strong>{` is about developer experience and how serverless helps you improve yours.`}</p>
      <p><strong parentName="p">{`Architecture principles`}</strong>{` talks about distributed architectures and what you'll want to think about.`}</p>
      <p><strong parentName="p">{`Lambdas, queues, etc`}</strong>{` explains the core building blocks of serverless backends and how you can use them.`}</p>
      <p><strong parentName="p">{`Robust backend design`}</strong>{` continues with ideas on resilience and reliability.`}</p>
      <p><strong parentName="p">{`Where to store data`}</strong>{` is all about different databases, their tradeoffs, and how they work. A core aspect of backend.`}</p>
      <p><strong parentName="p">{`Creating a REST API`}</strong>{` explains what is REST and what it isn't, how to design a good API, and walks you through a tutorial with working code.`}</p>
      <p><strong parentName="p">{`Using GraphQL`}</strong>{` shows you the benefits of GraphQL, when you should use it, and shares a tutorial where you deploy a serverless GraphQL API.`}</p>
      <p><strong parentName="p">{`Lambda pipelines`}</strong>{` talks about distributed data processing at scale and how you might use serverless for the task. Great dive into robust architecture design.`}</p>
      <p><strong parentName="p">{`Monitoring serverless apps`}</strong>{` gives you ideas on observability and how to ensure you'll know something's funky before users start yelling.`}</p>
      <p><strong parentName="p">{`Dev, QA, and prod`}</strong>{` shares common strategies for scaling as a team, avoiding mishaps, and when you should use which.`}</p>
      <p><strong parentName="p">{`Serverless performance`}</strong>{` touches cost optimization and focuses on how to keep your system fast and performant.`}</p>
      <p><strong parentName="p">{`Serverless Chrome puppeteer`}</strong>{` was hard to fit in the book, but it's such a darling I couldn't let go. Shows you how to run Serverless Chrome for browser automation.`}</p>
      <p><strong parentName="p">{`Handling secrets`}</strong>{` is an important topic on how to make sure your system doesn't get hacked. Leaking API keys is a common oopsie.`}</p>
      <p><strong parentName="p">{`Dealing with authentication`}</strong>{` talks about authentication, why it's hard, and shows you how to roll your own or use a 3rd party provider.`}</p>
      <p><strong parentName="p">{`Glossary`}</strong>{` defines commonly used words so you can look them up as you work.`}</p>
      <p><strong parentName="p">{`Appendix: More databases`}</strong>{` is everything you ever wanted to know about different databases and how to use them.`}</p>
      <p>{`Plus, Serverless Handbook `}<em parentName="p">{`really`}</em>{` looks great on your desk 😊`}</p>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><figure parentName="a" {...{
            "className": "gatsby-resp-image-figure",
            "style": {
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
    `}<span parentName="figure" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "890px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.05381165919282%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M326%2018l-74%201c-40%200-40%200-21%207a5077%205077%200%2000157%2062l-24%201c-23%202-25%203-23%205l1%203%201%202%201%203v1l2%204%202%203v3l1%203c1%203%202%202%208-9l5-8s18-2%2020-1l1%202%201%201%2016%207-1%201v1l1%202-1%201-2-1-4-2-8-2-5-2c-2%201-12%2021-18%2034-2%206-2%206-7%203-3-2-4-6-2-6l-2-1-4%201c-1%201-5%201-5-1l2-4c2-4%201-4-2-4-5%201-7%200-7-5-1-4-3-5-8-3-4%201-4%201-7-1-8-3-18-3-25%203l-3%202h7c7%200%2012%201%209%202l-14%201c-10%200-13%201-14%202-3%203-8%202-8%200s11-7%2013-7%201-2-2-2c-8-2-22%200-22%203l1%203c1%203%201%203-4%205l-7%203c-2%200-3%201-4%203%200%204-1%204-4%205-6%201-10%202-12%204s0%203%203%201c5-2%2016-2%2041-1%2041%203%2037%203%2037%206%200%202-1%203-6%203l-13-1c-9-1-8%200%204%205%209%203%209%204%204%207-4%202-6%202-9%201-14-8-32-15-38-16h-7l1%203c0%204%205%2014%207%2016%203%202%202%203-1%207l-4%204%2014%209%2013%209%2018-4%2018-3%207-14%208-14c2%200%204%202%204%204s0%202%201%201v3l-1-1c-1-1-1-1-3%204a587%20587%200%2001-3%2011l1%202-1%204c0%205-6%2019-8%2019l-2-1a76%2076%200%20017-19c0-3-3%202-7%2010l-4%208-23%206c-28%206-26%206-23%208l68%201h67V18l-18-1-57%201M1%2039v19l8-3%2016-6a715%20715%200%2001101-29l-63-1H1v20m151%2019l-2%201%201%201h3l-1%201c-4%201-3%204%202%206h7l5-2%203-1-2-1-8-3-6-3-2%201m-80%209c-6%203-2%206%207%204l6%201c0%201-4%202-7%201-3%200-4%202-1%203%204%201%2014-4%2012-7h-9l-7-1%205-1%204-1c-1-1-7-1-10%201m223-1c0%202-13%2014-16%2014-2%200-2%200%202%202s5%202%209%201l7-1%203-1-3-3-3-4c0-2%205-1%2019%205%2013%205%2013%205%2022%205%2014%200%2016-1%208-4-5-2-5-2-6-1-1%202-1%202-5%200a780%20780%200%2000-37-13m-191%209l-4%201%203%201c4%201%204%203-1%204-4%201-6%201-6-2l-5%201c-4%201-6%203-2%202%202%200%2010%205%2010%207l5-1%204-2h-1l-5-2c0-3%209-4%2010-1%200%201%201%202%202%201l4-1%203-2h-1c-2%200-11-5-11-7l-5%201m205%2011l-1%202-2%202c-1%203-2%203%2011%209%205%202%209%204%2010%203v-5l-1-1v-1l-1-1v-1l-8-5c-7-4-8-4-8-2M1%20155v69h174l-2-3-4-3-12-9-7-6c-8-5-12-10-10-12a880%20880%200%200142-60l2-1c0-1-5-3-8-2s-5%203-19%2024a696%20696%200%2000-22%2033l-3%203-3-2-4-3-7-6a1364%201364%200%2001-43-33A3494%203494%200%20003%2087c-2-1-2%202-2%2068m380-13l-5%203h-5c-3%200-3%200-5%206l-3%206c-3%201-5%201-8%204-5%203-5%202-1%206%204%205%202%2012-4%2014s-7%202-5-4c2-4%201-4-3-5-3-1-4%200-5%201v2l-1%201c-2%201-3%205-1%205l1-1%201-1-1%205c-2%203-2%203-1%204%202%202%200%202%2028-3%207-1%2012-2%2013-1l1-1%202-1h3l-2%204c-2%205-3%206-3%202%201-3%201-3-1-1s-6%2014-5%2015l14-3h4l7-3%204-1v-27l-11-6-11-5%206-2c8-3%2012-6%2012-10s-6-5-15-3m-46%203l-3%201c-1%200-4%206-3%207h4v1c-1%202%201%203%203%202%201-1%203%200%203%202s0%202%202%201%203%200%203%202%200%202%204%200c3-1%203-1%202-5-1-5-3-8-5-5-1%202-6%201-6-2l-1-3v-1c0-2-2-2-3%200m-137%2028l-7%204-4%202c-3-1-7%203-8%208-1%208%207%2016%2014%2015l7-5%205-10c6-11%207-13%204-15-2-3-5-2-11%201m191%2010c-3%208-3%208%202%207%206-1%209-11%205-13s-5-2-7%206m-38%2010h-4c-3%201-4%201-7%209-3%209-4%2011-2%2013%202%201%204-2%206-11%204-10%204-10%205-8l-2%208c-3%208-4%2012-1%2012l5-8%203-8c2-2%201%203-1%208-4%2010-3%2011%2014%207%2022-5%2024-6%2025-10%201-3%202-3-15%201l-15%202%201-6c2-7%201-9-4-8-3%201-5-1-2-1%201-1%200-1-2-1l-4%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/29fe1a26d49650b5d6922b06c0b10b7e/ca0a1/serverless-on-desk.webp 223w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/75680/serverless-on-desk.webp 445w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/8d1ba/serverless-on-desk.webp 890w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/3838e/serverless-on-desk.webp 1335w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/f992d/serverless-on-desk.webp 1440w"],
                  "sizes": "(max-width: 890px) 100vw, 890px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/29fe1a26d49650b5d6922b06c0b10b7e/853b2/serverless-on-desk.jpg 223w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/0a4fe/serverless-on-desk.jpg 445w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/7f80b/serverless-on-desk.jpg 890w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/dc6ba/serverless-on-desk.jpg 1335w", "/static/29fe1a26d49650b5d6922b06c0b10b7e/644c5/serverless-on-desk.jpg 1440w"],
                  "sizes": "(max-width: 890px) 100vw, 890px",
                  "type": "image/jpeg"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/static/29fe1a26d49650b5d6922b06c0b10b7e/7f80b/serverless-on-desk.jpg",
                  "alt": "Serverless Handbook on your desk",
                  "title": "Serverless Handbook on your desk",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
              "className": "gatsby-resp-image-figcaption"
            }}>{`Serverless Handbook on your desk`}</figcaption>{`
  `}</figure></a></p>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><span parentName="a" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px",
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2014c-8%203-8%202-8%2059%200%2056%200%2055%207%2059%204%203%20373%203%20378%200%206-4%206-3%206-59%200-57%200-56-8-60-6-2-370-2-375%201m10%2014l-1%209v9h4c6%200%2010-5%207-8-2-1-2-2-1-3%201-3%201-5-1-6-1-2-7-3-8-1m15%205l-1%206c0%206%202%209%206%207h3c2%200%202%200%202-6l-1-7c-1-2-3%202-3%206l-1%205c-2%200-3-2-3-8%200-4-1-5-2-3m13%203l3%207c2%205%202%206-1%206l-2%202c0%201%204%201%206-1l4-14c1-4-2-3-3%202s-1%205-4-2c-1-5-3-5-3%200m38-2c-4%205-1%2013%204%2013%202%200%206-5%206-7%200-6-7-10-10-6m12-1c-1%202%202%2013%204%2013l2-3c0-4%201-4%203%200%200%202%201%203%202%203%202-1%205-12%204-13h-1l-3%205-2-3c-1-3-1-3-3-2l-1%204-1%203-1-2c0-5-2-8-3-5m28%201c-4%204-1%2013%204%2013%202%200%205-4%205-7%200-7-6-10-9-6m13%205l1%207c1%200%202-1%202-5s1-6%202-6c2%200%202%201%202%205%201%207%203%208%204%201%200-7-1-9-6-9l-5%201v6m-26%2021c-6%202-9%206-9%2010%200%203%208%203%2010%200%204-5%2010-3%209%202%200%202-1%203-6%204-10%201-14%205-14%2013%200%209%2011%2014%2018%208%204-2%204-3%206%200%201%203%203%203%206-1%203-3%203-3%202-6-2-2-2-5-2-12l-1-12c-3-6-12-8-19-6m93%200c-7%202-11%206-11%2010%200%203%209%203%209%200%201-2%206-4%208-2l2%204c0%202-1%202-7%203-9%202-13%206-13%2013%200%205%201%208%205%2010%203%202%2010%201%2013-1l3-2%202%202c3%203%204%203%207-1%203-3%203-3%202-5-2-2-2-5-2-13%200-9%200-11-2-13-4-5-11-7-16-5m-52%202c-3%202-3%202-4%201%200-2-2-2-5-2h-4v38h10V85c0-14%201-16%205-16%203%200%203%201%203%2017l1%2013h9V86c0-14%201-17%205-17%203%200%204%202%204%2016l1%2014h3l5-1V66c-3-6-11-8-16-3l-3%203-2-3c-3-4-9-4-12-1m80-1c-2%200-3%205%200%207l6%201c6-1%206-1-4%2013-4%206-5%208-5%2012%200%205%200%205%205%203s13-2%2017%200c5%201%206%201%206-3s-5-8-12-8c-2%200-3-1-1-2l6-9c6-9%207-13%205-14h-23m38%200c-12%205-14%2028-3%2036%2012%208%2025-2%2024-20-1-13-11-20-21-16m38%202c-2%202-2%202-3%200%200-2-1-2-5-2h-4v19l1%2019h9V85c1-13%201-16%205-16%203%200%203%202%204%2016l1%2014h9V68c-2-7-11-11-17-5m44%204c-1%201%200%203%206%208l6%206-6%207c-6%206-7%209-5%209s16-15%2016-16l-8-8c-6-6-8-7-9-6m-80%203c-4%205-2%2022%203%2022%204%200%207-6%206-16-1-8-5-11-9-6m-36%2032c-7%202-7%202%202%203%2010%201%2010%201%204%2016h2c4-4%208-16%206-19h-14m-103%202a87%2087%200%2000105%209c4-3%201-3-7%200-14%204-19%205-33%206-21%201-39-3-57-12l-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/ca0a1/buy-now-amazon.webp 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ac56/buy-now-amazon.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/e92b6/buy-now-amazon.png 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png",
                "alt": "buy now amazon",
                "title": "buy now amazon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></a></p>
      <h1 {...{
        "id": "frequently-asked-questions"
      }}>{`Frequently Asked Questions`}</h1>
      <h2 {...{
        "id": "why-amazon"
      }}>{`Why Amazon?`}</h2>
      <p>{`She's a good book Friend and she deserves to hit the bestseller list.`}</p>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`oh hey look who's a #1 bestseller on Amazon`}<a parentName="p" {...{
            "href": "https://t.co/YCPn2xZGzt"
          }}>{`https://t.co/YCPn2xZGzt`}</a>{` `}<a parentName="p" {...{
            "href": "https://t.co/jl5a1lMAgU"
          }}>{`pic.twitter.com/jl5a1lMAgU`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/Swizec/status/1377377288895918082"
        }}>{`March 31, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`Oh damn, #6 in the general Computer Programming category 🚀`}<a parentName="p" {...{
            "href": "https://t.co/YCPn2xI5HV"
          }}>{`https://t.co/YCPn2xI5HV`}</a><br parentName="p"></br><br parentName="p"></br>{`Paperback is #22 🤘 `}<a parentName="p" {...{
            "href": "https://t.co/FsYbt2pbw6"
          }}>{`pic.twitter.com/FsYbt2pbw6`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/Swizec/status/1377618407869325320"
        }}>{`April 1, 2021`}</a></blockquote>
      <p>{`🤘`}</p>
      <h2 {...{
        "id": "999-for-kindle-are-you-sure-your-book-is-worth-more"
      }}>{`$9.99 for Kindle are you sure? Your book is worth more.`}</h2>
      <p>{`Not a fake question, I promise.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/22d38a9c197ed5a26356a681cefee029/51800/kindle-price-question.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.98206278026906%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'193\\'%20viewBox=\\'0%200%20400%20193\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%208c-11%206-2%2023%2010%2018%202-1%205-6%205-9%200-7-8-12-15-9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/22d38a9c197ed5a26356a681cefee029/ca0a1/kindle-price-question.webp 223w", "/static/22d38a9c197ed5a26356a681cefee029/75680/kindle-price-question.webp 445w", "/static/22d38a9c197ed5a26356a681cefee029/8d1ba/kindle-price-question.webp 890w", "/static/22d38a9c197ed5a26356a681cefee029/31d32/kindle-price-question.webp 1196w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/22d38a9c197ed5a26356a681cefee029/e92b6/kindle-price-question.png 223w", "/static/22d38a9c197ed5a26356a681cefee029/e66bf/kindle-price-question.png 445w", "/static/22d38a9c197ed5a26356a681cefee029/4ef49/kindle-price-question.png 890w", "/static/22d38a9c197ed5a26356a681cefee029/51800/kindle-price-question.png 1196w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/22d38a9c197ed5a26356a681cefee029/4ef49/kindle-price-question.png",
                "alt": "kindle price question",
                "title": "kindle price question",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
      <p>{`Amazon decided that kindle books should be $9.99. You get a 70% margin. Choose higher and your margin falls to 30%.`}</p>
      <p>{`That means a $22 and a $9.99 book make the same revenue for the author. In that case making `}<a parentName="p" {...{
          "href": "https://serverlesshandbook.dev"
        }}>{`Serverless Handbook`}</a>{` more accessible is the better choice 😊`}</p>
      <h2 {...{
        "id": "49-for-the-paperback-does-it-read-itself"
      }}>{`$49 for the paperback does it read itself??`}</h2>
      <p>{`Also not a fake question 😂`}</p>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`The physical version is 50USD! Does it read itself ?`}</p>{`— diego (@dxvgx) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/dxvgx/status/1377378042750844930"
        }}>{`March 31, 2021`}</a></blockquote>
      <p>{`You know how most books you buy `}<em parentName="p">{`aren't`}</em>{` color and look like they were printed on toilet paper? This week I learned why.`}</p>
      <p><img parentName="p" {...{
          "src": "../images/paperback-royalties.png",
          "alt": "Paperback royalty structure"
        }}></img></p>
      <p>{`That's right, it costs $26 to print each copy of `}<a parentName="p" {...{
          "href": "https://serverlesshandbook.dev"
        }}>{`Serverless Handbook`}</a>{`. Add distribution costs and Amazon overhead ...`}</p>
      <p>{`I didn't want you to read toilet paper.`}</p>
      <h2 {...{
        "id": "amazon-doesnt-show-your-book-in-my-country"
      }}>{`Amazon doesn't show your book in my country`}</h2>
      <p>{`Sorry that's out of my hands 😔 I clicked all the buttons and flipped all the checkboxes and said `}<em parentName="p">{`"Widest distribution possible please!"`}</em></p>
      <p>{`You can `}<a parentName="p" {...{
          "href": "https://www.amazon.com/dp/0578887916"
        }}>{`try buying from Amazon's US store directly`}</a></p>
      <h2 {...{
        "id": "i-dont-like-amazon-dont-have-kindle-and-killing-trees-is-bad-how-can-i-read-serverless-handbook"
      }}>{`I don't like Amazon, don't have Kindle, and killing trees is bad. How can I read Serverless Handbook?`}</h2>
      <p>{`You can buy the `}<a parentName="p" {...{
          "href": "https://gum.co/NsUlA"
        }}>{`live digital version on Gumroad`}</a>{`. Otherwise included with kindle/paperback purchase :)`}</p>
      <Box sx={{
        mt: 10,
        textAlign: "center"
      }} mdxType="Box">
  <a className="gumroad-button" href="https://gum.co/NsUlA" data-gumroad-single-product="true" target="_blank" rel="noopener noreferrer">
    Get Serverless Handbook Digital
  </a>
      </Box>
      <h1 {...{
        "id": "serverless-handbook-in-the-wild"
      }}>{`Serverless Handbook in the wild`}</h1>
    </Container>
    <ThemeUIGrid gap={2} columns={[1, 3]} sx={{
      px: [1, 3]
    }} mdxType="ThemeUIGrid">
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`I bought the excellent book Serverless Handbook from `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` `}<br parentName="p"></br><br parentName="p"></br>{`I highly recommend it! `}<a parentName="p" {...{
            "href": "https://t.co/J839kYt3zr"
          }}>{`pic.twitter.com/J839kYt3zr`}</a></p>{`— Oscar Pagani (@opagani) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/opagani/status/1383293337029922820"
        }}>{`April 17, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`That's easy just send me a signed copy. Btw, now I understand why it originally was ~50USD `}<a parentName="p" {...{
            "href": "https://t.co/FOcgebeBqD"
          }}>{`pic.twitter.com/FOcgebeBqD`}</a></p>{`— diego (@dxvgx) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/dxvgx/status/1383209549809602570"
        }}>{`April 17, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`Thanks `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{`! Reading the earlier versions of this online a couple years ago was super helpful! `}<a parentName="p" {...{
            "href": "https://t.co/cSbQo1Ce5z"
          }}>{`pic.twitter.com/cSbQo1Ce5z`}</a></p>{`— Brandon 🚀 Blitz.js⚡️ (@flybayer) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/flybayer/status/1383058155555393541"
        }}>{`April 16, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`I want a signed copy! `}<a parentName="p" {...{
            "href": "https://t.co/jvczaIqM42"
          }}>{`pic.twitter.com/jvczaIqM42`}</a></p>{`— JuanGiraldo (@juanggiraldo) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/juanggiraldo/status/1382739132758290434"
        }}>{`April 15, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`It has arrived 🎉`}<a parentName="p" {...{
            "href": "https://twitter.com/hashtag/ServerlessHandbook?src=hash&ref_src=twsrc%5Etfw"
          }}>{`#ServerlessHandbook`}</a>{` `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` `}<a parentName="p" {...{
            "href": "https://t.co/LVjHVbAuV2"
          }}>{`pic.twitter.com/LVjHVbAuV2`}</a></p>{`— Kevin Østerkilde 🇩🇰 (@Kosai106) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/Kosai106/status/1381551022464765955"
        }}>{`April 12, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}><a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` kids these days and their pesky serverless development! `}<a parentName="p" {...{
            "href": "https://t.co/ufkwZyTVGf"
          }}>{`pic.twitter.com/ufkwZyTVGf`}</a></p>{`— Chase (@chagwood) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/chagwood/status/1381368867289763846"
        }}>{`April 11, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`Cracked open my physical copy tonight `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` 👌🏻 I will learn aws and use it for evil `}<a parentName="p" {...{
            "href": "https://t.co/snDo22m9hp"
          }}>{`pic.twitter.com/snDo22m9hp`}</a></p>{`— Ryan Magoon (@Ryan_Magoon) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/Ryan_Magoon/status/1381053872370814979"
        }}>{`April 11, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}><a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` this is my stack of handbooks that I keep handy. `}<a parentName="p" {...{
            "href": "https://t.co/6pVfYZ4ATs"
          }}>{`pic.twitter.com/6pVfYZ4ATs`}</a></p>{`— Cody Averett (@code_e_averett) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/code_e_averett/status/1380573360300646403"
        }}>{`April 9, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`What has two thumbs and just got `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{`’s new book? `}<a parentName="p" {...{
            "href": "https://t.co/slocl14mbX"
          }}>{`pic.twitter.com/slocl14mbX`}</a></p>{`— Adam Rackis (@AdamRackis) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/AdamRackis/status/1379184860586184704"
        }}>{`April 5, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}><a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` `}<a parentName="p" {...{
            "href": "https://twitter.com/hashtag/serverlesshandbook?src=hash&ref_src=twsrc%5Etfw"
          }}>{`#serverlesshandbook`}</a>{` This is the first physical comp sci text book I’ve brought in over twenty years. I find that most of them are out of date the moment they’re printed but Swizec has done an amazing job and the content will be relevant for a good few years to come. `}<a parentName="p" {...{
            "href": "https://t.co/BdAAecEVjA"
          }}>{`pic.twitter.com/BdAAecEVjA`}</a></p>{`— Jon Howard (@TheAppyWriter) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/TheAppyWriter/status/1378688644987371526"
        }}>{`April 4, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`Following the trend 📒`}<br parentName="p"></br>{`Trying to up my game lately 👨‍💻 `}<a parentName="p" {...{
            "href": "https://t.co/GV9zryhYNw"
          }}>{`pic.twitter.com/GV9zryhYNw`}</a></p>{`— 𖤐 𝐋𝐔𝐊𝐘 𝐕𝐉 ( LukyVj ) 🐶 🚀 🌝 (@LukyVJ) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/LukyVJ/status/1384835578932387841"
        }}>{`April 21, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}><a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` got the serverless handbook! It looks great. It’s a lot thicker than I would’ve thought reading it online`}</p>{`— Michael (@mikedubcurry) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/mikedubcurry/status/1387920478166265857"
        }}>{`April 30, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`My man `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` went and sent me a signed first edition of this soon to be classic 👊 `}<a parentName="p" {...{
            "href": "https://t.co/Gw8cTIY7pH"
          }}>{`pic.twitter.com/Gw8cTIY7pH`}</a></p>{`— Adam Rackis (@AdamRackis) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/AdamRackis/status/1388192278884331530"
        }}>{`April 30, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`Looking forward to reading this! Thanks `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{`!! `}<a parentName="p" {...{
            "href": "https://t.co/2A9L94okV1"
          }}>{`pic.twitter.com/2A9L94okV1`}</a></p>{`— Liz Lam (@grepliz) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/grepliz/status/1389677853013286913"
        }}>{`May 4, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`I just got my copy of Serverless Handbook from `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{` . First few chapters are great and I'm excited to go through the rest. `}<a parentName="p" {...{
            "href": "https://t.co/1Y4Re4i7a3"
          }}>{`pic.twitter.com/1Y4Re4i7a3`}</a></p>{`— Roy Anger (@royanger) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/royanger/status/1389976070959640578"
        }}>{`May 5, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`I just got my signed copy of Serverless Handbook from `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@Swizec`}</a>{`, I know what I’m gonna do this weekend 😎 `}<a parentName="p" {...{
            "href": "https://t.co/MAhADMegOW"
          }}>{`pic.twitter.com/MAhADMegOW`}</a></p>{`— Mate Nemeth (@__MateN) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/__MateN/status/1390360722299817987"
        }}>{`May 6, 2021`}</a></blockquote>
      <blockquote {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`Learning about `}<a parentName="p" {...{
            "href": "https://twitter.com/hashtag/serverless?src=hash&ref_src=twsrc%5Etfw"
          }}>{`#serverless`}</a>{` from `}<a parentName="p" {...{
            "href": "https://twitter.com/Swizec"
          }}>{`@swizec`}</a>{`'s new Serverless Handbook and ... `}<a parentName="p" {...{
            "href": "https://t.co/zvZSs1iMas"
          }}>{`https://t.co/zvZSs1iMas`}</a>{` `}<a parentName="p" {...{
            "href": "https://t.co/DOHA80SYLu"
          }}>{`pic.twitter.com/DOHA80SYLu`}</a></p>{`— scisteffan (@scisteffan) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/scisteffan/status/1391809403792371725"
        }}>{`May 10, 2021`}</a></blockquote>
    </ThemeUIGrid>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      